import script from "./company-inbox-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./company-inbox-modal.vue?vue&type=script&setup=true&lang=js"

import "./company-inbox-modal.vue?vue&type=style&index=0&id=2d68b8e2&lang=scss"

const __exports__ = script;

export default __exports__